<template>
	<div id="load" v-if="globalLoader || !isSiteStatusCalled">
        <div id="load-inner"><i class="fa fa-spinner fa-spin"></i></div>
    </div>
	<div v-if="onLine && isSiteStatusCalled">
		<template
			v-if="$route.name == 'Login' || $route.name == 'SignUp' || $route.name == 'ForgetPassword' || $route.name == 'Rules'  || $route.name == 'ResponsibleGaming'">

			<router-view v-if="$siteSettings?.data"></router-view>

		</template>		
		<template v-else>
			<template v-if="!underMaintenance && $route.name != 'NotFound'">
				<Header v-if="checkForHeaderShow()" @updateAuthToken="refreshAuthToken"></Header>
			</template>

			<router-view v-if="checkRoute()"></router-view>

			<section class="sidebar-nav" loading="lazy" v-else>
				<div class="main">
					<div class="container-fluid">
						<div class="row" v-cloak>
							<router-view v-if="$siteSettings?.data">
							</router-view>
						</div>
					</div>
				</div>
			</section>

			<Footer v-if="!['matka-details','cricketFightDetails','NotFound'].includes($route.name)"></Footer>
		</template>
		<div  class="toster-wrapper" v-if="successMsg || errorMsg">
			<SuccessModal v-if="successMsg" :message="successMsg" />
			<ErrorModal v-if="errorMsg" :message="errorMsg" />
		</div>
		<Offers v-if="$siteSettings?.data?.offer?.image"/>
		<CopyUserIdModal v-if="$auth.status" />
		<NotificationAlert @allowNotifications="allowNotifications" @cancelNotifications="cancelNotifications"/>
	</div>

</template>

<script>
import { defineAsyncComponent } from 'vue';
import { setHeaders } from '@/shared/services/headers';
import { AUTH_TOKEN } from "./shared/constants/cookies-const";
import { mapGetters } from 'vuex';
import axios from "axios";
import socketService from "./socket/sport-socket-service";
import confetti from "canvas-confetti";
export default {
	name: "App",
	data() {
		return {
			onLine: navigator.onLine,
			showBackOnline: false,
			refreshInit: false,
			isSiteStatusCalled: false
		}
	},
	components: {
		NotificationAlert: defineAsyncComponent(() =>
            import('./shared/components/modal/NotificationAlert.vue')
        ),
		Header: defineAsyncComponent(() =>
            import('./shared/components/header/Header.vue')
        ),
		Footer: defineAsyncComponent(() =>
            import('./shared/components/footer/Footer.vue')
        ),
		ErrorModal: defineAsyncComponent(() =>
            import('./shared/components/modal/ErrorModal.vue')
        ),
		SuccessModal: defineAsyncComponent(() =>
            import('./shared/components/modal/SuccessModal.vue')
        ),
		CopyUserIdModal: defineAsyncComponent(() =>
			import('./shared/components/modal/CopyUserIdModal.vue')
		),
		Offers: defineAsyncComponent(() =>
			import('./shared/components/header/Offers.vue')
		),
	},
	computed: {
		...mapGetters(['eventDetailHideSections','successMsg', 'errorMsg', 'siteVersion', 'underMaintenance','logInData','globalLoader']),
		routePath() {
			return this.$route.name
		}
	},
	mounted() {
		//for use on js pages
		window.store = this.$store;
		window.cookies = this.$cookies;
		window.router = this.$router;
		window.authorization_token = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`
		setHeaders();
		this.$errorToast(null);
		this.$successToast(null);
	},
	async created() {
		if (this.$siteSettings?.data && this.$siteSettings?.data?.front_css != null && this.$siteSettings?.data?.front_css != '') {
			const styleElement = document.createElement('style');
			styleElement.type = 'text/css';
			styleElement.appendChild(document.createTextNode(this.$siteSettings?.data?.front_css));
			document.head.insertAdjacentElement('beforeend', styleElement);
		}
		await this.getSiteVersion();
		this.socketAllEvents();
		this.$router.beforeEach((to, from, next) => {
			if(from.name == 'change-password' && to.name == 'Sports'){
				this.handleUserIdAndOffer()
			}
			next();
		});
	},
	methods: {
		requestNotificationPermission() {
			if (!('Notification' in window)) {
				console.log('This browser does not support notifications.');
				return;
			}

			if (Notification.permission === 'granted') {				
				this.getSubscriptionData();
			} else if (Notification.permission !== 'denied') {
				this.openNotificationBox()
			}
		},
		openNotificationBox(){
			setTimeout(() => {
				this.$helper.openModal('#notification-alert')
			}, 200);
		},
		allowNotifications(){
			Notification.requestPermission().then(permission => {
				if (permission === 'granted') {
					console.log('Notification permission granted.');
					this.getSubscriptionData();
				}
			});
		},
		cancelNotifications(){
			let user=this.$store.getters.stateUser;
			user.notificationUnsubscribed=1;
			this.$store.dispatch('setUser', user);
		},
		async getSubscriptionData(){
			let user=this.$store.getters.stateUser;
			user.notificationSubscribed=1;
			this.$store.dispatch('setUser', user);
			if ('serviceWorker' in navigator) {
				try {
					await navigator.serviceWorker.register('/service-worker.js').then(async registration => {

						setTimeout(async () => {
							if ('PushManager' in window) {
								if (registration.pushManager) {
									// Subscribe to push notifications
									const subscription = await registration.pushManager.subscribe({
										userVisibleOnly: true,
										applicationServerKey: process.env.VUE_APP_PUBLIC_VAPID_KEY
									});
									this.deviceData=subscription
									this.subscribeNotifications()
								} else {
									console.warn('PushManager is not available');
								}
							} else {
								console.warn('Push notifications are not supported');
							}
						}, 1000)

					}).catch(e => {
						console.log(e);
					});				
				} catch (error) {
					console.error('Service Worker registration failed:', error);
				}
			} else {
				console.warn('Service workers are not supported in this browser.');
			}
		},
		subscribeNotifications(){
			let data = {
				"deviceData": this.deviceData,
				"domainName": window.location.host,
				};
				this.$apiCall('post', 'SUBSCRIBE_NOTIFICATION', data, 'notification').then(response => {
				this.loadingSignUp = false;
			}).catch(error => {
				this.loadingSignUp = false;
				if (error)
					this.$errorToast(error[0]);
			});
		},
		checkRoute() {
			let routeName = this.$route.name;
			let routeCollection = [
				'Wallet',
				'deposit-payment-method',
				'withdrawal-details',
				'add-account',
				'wallet-history',
				'wallet-history-detail',
				'my-id',
				'bonus'
			]
			return routeCollection.includes(routeName)
		},
		getGlobaLoader() {
			return this.$store.getters.globalLoader;
		},
		getSiteVersion() {
			this.$store.dispatch('setGlobalLoader', true);
			this.$apiCall('get', 'GET_SITE_VERSION', null, 'user', { domain: window.location.hostname }).then(async response => {
				if (response && response.status == 200) {
					this.$store.dispatch('setGlobalLoader', false);
					if (response?.data?.status === 0) {
						this.$errorToast(response.data.debug[0]);
					} else {
						let resData = response.data.data;
						let currentVersion = resData.version;
						let userSystemVersion = this.siteVersion || 0;
						if (!userSystemVersion || currentVersion != userSystemVersion || !this.$siteSettings?.data) {
							this.$store.dispatch('setSiteVersion', currentVersion);
							this.isSiteStatusCalled = false;
							this.getSiteSettingsServiceCall();
						} else {
							this.setSiteSttings(this.$siteSettings?.data);
						}
						if (resData.maintenance) {
							const { from_date, to_date } = resData.maintenance;
							const fromDateTime = new Date(from_date).getTime();
							const toDateTime = new Date(to_date).getTime();
							const currentDateTime = Date.now();
							
							const isInMaintenanceWindow = fromDateTime <= currentDateTime && currentDateTime <= toDateTime;
							if (fromDateTime && toDateTime && isInMaintenanceWindow) {
								this.$store.dispatch('setUnderMaintenance', resData.maintenance);
								this.$router.push({ name: 'Maintenance' });
							}
						}
						else {
							if(this.underMaintenance) {
								this.$router.push('/home');
							}
							this.$store.dispatch('setUnderMaintenance', null); 
						}
					}
				}
			}).catch(error => {
				this.$store.dispatch('setGlobalLoader', false);
				if (error) {
					this.$errorToast(error[0]);
				}
			});
		},
		getSiteSettingsServiceCall() {
			this.$store.dispatch('setGlobalLoader', true);
			this.$apiCall('get', 'GET_SITE_SETTINGS', null, 'user', { domain: window.location.hostname }).then(async response => {
				if (response && response.status == 200) {
					this.$store.dispatch('setGlobalLoader', false);
					if (response?.data?.status === 0) {
						this.$errorToast(response.data.debug[0]);
					} else {

						let resData = response?.data.data;let casino;
						if(response?.data.data.casino_url) {
							const getCasinoGame = async () => {
							let gameResp = await axios.get(response?.data.data.casino_url)
							return gameResp.data
							};
							casino = await getCasinoGame();
						} else {
							casino = response?.data.data?.casino
						}	
						this.$store.dispatch('setSettings', resData);
						this.$store.dispatch('setGamesData', casino);
						this.setSiteSttings(resData.site_settings);

					}
				}
			}).catch(error => {
				if (error) {
					this.$store.dispatch('setGlobalLoader', false);
					this.$errorToast(error[0]);
				}
			});
		},
		async setSiteSttings(siteData) {
			try {
				if (siteData.language_translate_list) {
					this.$setCurrentLangData(siteData.language_translate_list, siteData.language_code, siteData.aws_url)
					this.$store.dispatch('setLanguagesData', siteData.language_translate_list);
				}
				this.$store.dispatch('setSettings', siteData);

				this.setManifest(siteData);
				if(siteData.g_tags) {
					this.setGoogleAnalyticsTag(siteData.g_tags)
				}
				if(siteData.meta_pixel_code) {
					this.addFacebookPixel(siteData.meta_pixel_code);
				}
				const favElement = document.createElement('link');
				favElement.rel = 'icon';
				favElement.href = siteData?.aws_url + siteData.storage_path.domain_image + siteData.fav_logo;
				document.head.insertAdjacentElement('beforeend', favElement);
				const title = document.getElementById("title");
				title.text = siteData?.domain_name;
				if(siteData.meta_tags) {
					document.head.innerHTML += siteData.meta_tags;
				};
				if(siteData.g_tags) {
					this.setGoogleAnalyticsTag(siteData.g_tags);
				};
				if(siteData.meta_pixel_code) {
					this.addFacebookPixel(siteData.meta_pixel_code);
				}
				if(siteData.site_map) {
					const sitemapLink = document.createElement("link");
					sitemapLink.rel = "sitemap";
					sitemapLink.type = "application/xml";
					sitemapLink.title = "Sitemap";
					sitemapLink.href = siteData.aws_url + siteData.storage_path.site_map + siteData.site_map;
					document.head.appendChild(sitemapLink);
				};
				try {
					if (siteData.front_css != null && siteData.front_css != '') {
						const styleElement = document.createElement('style');
						styleElement.type = 'text/css';
						styleElement.appendChild(document.createTextNode(siteData.front_css));
						document.head.insertAdjacentElement('beforeend', styleElement);
					}
				} catch (error) {
					console.log("ERROR 1: ", error);
				}
				if (this.$auth?.status){
					this.getWalletBalance();
				}
				if(!this.$auth?.status) {
					this.setRoute();
				}  
				this.isSiteStatusCalled = true;
				if (this.$auth?.status) {
					this.getFavourites();
					if(this.$store.getters.stateUser.notificationUnsubscribed==1){
						return;
					}
					if(this.$store.getters.stateUser.notificationSubscribed!=1) {
						this.requestNotificationPermission()
					}
				}
				// Userid and offer ------------------------------------------
				if(this.$auth?.status) {
					if(this.$auth?.user?.last_login_at){
						this.handleUserIdAndOffer();
					}
				}
				//-----------------------------------------------------------
			} catch (error) {
				this.$errorToast(error);
			}
		},
		// Userid and offer ------------------------------------------------------
		handleUserIdAndOffer(){
			if(this.logInData?.logInWithMobile){
				if(!this.logInData?.userIds?.includes(this.$auth?.user?.userid )){
					this.showUserId()
				}
				else {
					this.handleOffer();
				}
			}
			else{
				if(!this.logInData?.userIds?.includes(this.$auth?.user?.userid )){
					let newUserIdsList = this.logInData?.userIds || [];
					newUserIdsList.push(this.$auth?.user?.userid)
					let data = {
						"logInWithMobile": this.logInData?.logInWithMobile,
						"userIds": newUserIdsList
					}
					this.$store.dispatch('setLogInData', data);
				}
				this.handleOffer();
			}
		},
		handleOffer(){
			let is_offer = this.$store.getters.is_offer;
			if (this.$auth.status && this.$siteSettings?.data.offer != null && is_offer && this.$siteSettings?.data?.business_type == 2) {
				setTimeout(() => {
					this.$helper.openModal("#offer_pop_up");
				}, 200);
			}
		},
		showUserId() {
			this.callAnimation();
            setTimeout(() => {
				this.$helper.openModal('#useridmodal');
			}, 200);
        },
		callAnimation(){
			let duration = 1000;
			let end = Date.now() + duration;
			function frame() {
				confetti({
					particleCount: 7,
					angle: 60,
					spread: 55,
					origin: { x: 0 },
				});
				confetti({
					particleCount: 7,
					angle: 120,
					spread: 55,
					origin: { x: 1 },
				});

				if (Date.now() < end) {
					requestAnimationFrame(frame);
				}
			}

			frame(); 
		},
		//-------------------------------------------------------------------
		setRoute() {
			const routeName = this.$route.name;
			const authRoutes = ['SignUp', 'Login', 'ForgetPassword']
			if(this.$siteSettings?.data && this.$siteSettings?.data?.business_type == 1) {
				this.$router.push({name: 'Login'})
			} 
		},
		setGoogleAnalyticsTag(gTag) {
			let script1 = document.createElement('script');
			script1.async = true;
			script1.src = `https://www.googletagmanager.com/gtag/js?id=${gTag}`;

			let script2 = document.createElement('script');
			script2.innerHTML = `
				window.dataLayer = window.dataLayer || [];
				function gtag(){dataLayer.push(arguments);}
				gtag('js', new Date());
				gtag('config', '${gTag}');
			`;

			document.head.appendChild(script1);
			document.head.appendChild(script2);
		},
		addFacebookPixel(pixelId) {
			const script = document.createElement('script');
			script.innerHTML = `
				!function(f,b,e,v,n,t,s)
				{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
				n.callMethod.apply(n,arguments):n.queue.push(arguments)};
				if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
				n.queue=[];t=b.createElement(e);t.async=!0;
				t.src=v;s=b.getElementsByTagName(e)[0];
				s.parentNode.insertBefore(t,s)}(window, document,'script',
				'https://connect.facebook.net/en_US/fbevents.js');
				fbq('init', '${pixelId}');
				fbq('track', 'PageView');
			`;
			document.head.appendChild(script);

			// Add the noscript image
			const noscript = document.createElement('noscript');
			noscript.innerHTML = `
				<img height="1" width="1" style="display:none"
					src="https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1"/>
			`;
			document.head.appendChild(noscript);
		},
		setManifest(resData) {
			let manifestName = resData?.domain_name.charAt(0).toUpperCase() + resData?.domain_name.slice(1).toLowerCase();
			var dynamicManifest = {
				name: manifestName,
				short_name: manifestName,
				start_url: window.location.origin,
				display: 'standalone',
				icons: [{
					src: resData?.app_logo ? resData?.aws_url + resData.storage_path.domain_image + resData?.app_logo : resData?.aws_url + resData.storage_path.domain_image + resData.fav_logo,
					sizes: "256x256 512x512 192x192 144x144",
					type: "image/png",
					purpose: 'any'
				}]
			}
			
			// Manifest Blob
			const stringManifest = JSON.stringify(dynamicManifest);
			const blob = new Blob([stringManifest], { type: 'application/json' });
			const manifestURL = URL.createObjectURL(blob);
			
			// Manifest Creation
			const favElement = document.createElement('link');
			favElement.rel = 'manifest';
			favElement.href = manifestURL;
			document.head.insertAdjacentElement('beforeend', favElement);
			
			// IOS APK Logo
			let logo = resData?.aws_url + resData.storage_path.domain_image + resData.logo;
			document.querySelector('#appleIcon').setAttribute('href', logo);
			document.querySelector('#appleLaunchIcon').setAttribute('href', logo);

			// IOS App title
			const metaTag = document.createElement('meta');
			metaTag.setAttribute('name', 'apple-mobile-web-app-title');
			metaTag.setAttribute('content', manifestName);
			document.head.insertAdjacentElement('beforeend', metaTag);

		},
		setGoogleAnalyticsTag(gTag) {
			let script1 = document.createElement('script');
			script1.async = true;
			script1.src = `https://www.googletagmanager.com/gtag/js?id=${gTag}`;

			let script2 = document.createElement('script');
			script2.innerHTML = `
				window.dataLayer = window.dataLayer || [];
				function gtag(){dataLayer.push(arguments);}
				gtag('js', new Date());
				gtag('config', '${gTag}');
			`;

			document.head.appendChild(script1);
			document.head.appendChild(script2);
		},
		getWalletBalance() {
			let authToken = this.$cookies.get(AUTH_TOKEN);
			if (!authToken) return;
			let headers = {
				'Authorization': `Bearer ${authToken}`
			}
			this.$apiCall('post', 'WALLET_BALANCE').then(response => {
				if (response && response.status == 200 && response.data) {
					let user = this.$store.getters.stateUser;
					user.balance = response.data.bl;
					user.expl = response.data.ex;
					user.bets_count = response.data.bc;
					user.earnBonus = response.data.eb;
					this.$store.dispatch('setUser', user);
					if ((user.exp - this.$dateTime.currentTimestamp()) < 10) {
						this.refreshAuthToken(headers);
					} else {
						setTimeout(function () {
							this.getWalletBalance();
						}.bind(this), 2000);
					}
				} else {
					this.$cookies.keys().forEach(cookie => this.$cookies.remove(cookie))
					this.$store.dispatch('resetAllState');
				}
			}).catch(error => {
				if (error) {
					this.$errorToast(error);
				}
			});
		},
		refreshAuthToken(refresh = false) {
			this.refreshInit = true;
			this.$apiCall('post', 'AUTH_REFRESH').then(response => {
				let user = this.$store.getters.stateUser;
				user.token = response.data.data.token;
				user.exp = response.data.data.exp;
				this.$cookies.set(AUTH_TOKEN, response.data.data.token);
				this.$store.dispatch('setToken', `Bearer ${response.data.data.token}`);
				window.authorization_token = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`
				//for add on all APIs
				axios.defaults.headers.common['Authorization'] = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`;
				this.$store.dispatch('setUser', user);
				this.refreshInit = false;
				if(refresh) {
					router.go();
				}
			}).catch(error => {
				if (error) {
					this.$errorToast(error[0]);
				}
				this.refreshInit = false;
			});
		},
		getFavourites() {
			let data = {
				"game_type": 1
			}
			this.$apiCall('post', 'GET_FAVOURITE_LIST', data).then(response => {
				if (response) {
					if (response.status == 200) {
						if (response?.data?.status != 0) {
							var allData = response.data.data;
							var ids = [];
							for (var i = 0; i < allData.length; i++) {
								ids.push(allData[i].match_id)
							}
							this.$store.dispatch('setFavouriteGames', ids)
						}
					}
				}
			}).catch(error => {
				if (error) {
				}
			});
		},
		updateOnlineStatus(e) {
			const {
				type
			} = e;
			this.onLine = type === 'online';
		},
		goToTop() {
			window.scrollTo({
				top: 0,
				behavior: "smooth"
			});
		},
		socketAllEvents() {
			if (this.$store.getters.stateUser) {
				socketService.emit("sub", 'depositRequest-' + this.$store.getters.stateUser.userid);
				socketService.emit("sub", 'logout-' + this.$store.getters.stateUser.userid);
				socketService.emit("sub", 'banned-' + this.$store.getters.stateUser.userid);

				socketService.on("DepositRequest", (data) => {
					if (data.type == "myId") {
						if (data.notify_type == 1) {
							this.$store.dispatch('setNotification');
							this.$successToast('New Notification...')
						}
					}
				});
				socketService.on("logout", (data) => {
					if (data.type == "logout") {
						// logout user from users
						// if (data.notify_type == 1) {
						// 	this.$store.dispatch('setNotification');
						// 	this.$successToast('New Notification...')
						// }
					}
				});
				socketService.on("banned", (data) => {
					if (data.type == "match_ban") {
						// match ban condition
					} else if (data.type == 'league_ban') {
						// league ban condition
					}
				});

			}
		},
		checkForHeaderShow() {
			 if (this.eventDetailHideSections && this.eventDetailHideSections.includes('show_full_screen') && this.routePath == 'SportsEventDetail') {
				return false;
			} else {
				return true;
			}
		},
	},
	watch: {
		onLine(v) {
			if (v) {
				this.showBackOnline = true;
				setTimeout(() => {
					this.showBackOnline = false;
				}, 1000);
			}
		}
	}
};
</script>

<style>
	[v-cloak] {
		display: none;
	}
</style>
